// Bundled artwork for the seeded event buckets, keyed by slug.
//
// These ship with the site so the browse tiles look finished before anyone
// uploads anything; an admin-uploaded icon always wins over them, and
// `CategoryIcon` falls back to a name-matched glyph when neither exists.
//
// Shared rather than per-component: the same bucket has to look the same in
// the explore row, the header menu and the sibling rail at the foot of a
// landing page.
import xmasIcon from '@/assets/icons/xmas.png';
import fireIcon from '@/assets/icons/fire.png';
import musicIcon from '@/assets/icons/music.png';
import micIcon from '@/assets/icons/mic.png';
import pumpkinIcon from '@/assets/icons/pumpkin.png';
import snowIcon from '@/assets/icons/snowman.png';

const BUNDLED_ICONS = {
  christmas: xmasIcon,
  'new-year': fireIcon,
  'new-years': fireIcon,
  music: musicIcon,
  comedy: micIcon,
  standup: micIcon,
  'standup-comedy': micIcon,
  fests: pumpkinIcon,
  fest: pumpkinIcon,
  garba: pumpkinIcon,
  seasonal: snowIcon,
};

/** Admin upload → bundled art → null (which CategoryIcon turns into a glyph). */
export const subcategoryIcon = (subcategory) =>
  subcategory?.icon || BUNDLED_ICONS[subcategory?.slug] || null;
